// extracted by mini-css-extract-plugin
export default {"platformGlance":"PlatformGlance_platformGlance__A8Uzx","content":"PlatformGlance_content__zjIbG","image":"PlatformGlance_image__VlbOa","circle":"PlatformGlance_circle__R1gAn"};